import { useState } from 'react';

export function useDeviceDetect() {
  // Lazy initializer reads UA synchronously at mount so `isMobile` is correct
  // on the first render, preventing a brief `position: fixed` flash on mobile.
  const [isMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    return Boolean(
      userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
    );
  });

  return { isMobile };
}
